const PATH = process.env.APP_SUBPATH || '';

const RoutePaths = {
    ROOT: `${PATH}/`,
    DASHBOARD: `${PATH}/dashboard`,
};

export default RoutePaths;
